/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Reference/view.blocks to change it.
import * as fromAggregate from 'Data/aggregate.js'
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Reference({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Reference"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let latestEventsLastEventIdValueData = fromData.useDataValue({ viewPath,
context: 'latest_events',
path: 'last_event_id',
})
let eventIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'id',
})
let aggregateData = fromAggregate.equals(latestEventsLastEventIdValueData, eventIdValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}